import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取列表
   */
  getExampineList(currentPage: number, pageSize: number, obj?: any) {
    let params: any = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
    }
    if (obj.filter) {
      params.filter = obj.filter
    }
    if (obj.reviewStatus != null) {
      params.reviewStatus = obj.reviewStatus
    }
    return Ajax.get(``, {
      params: params,
    })
  },
  /**
   * 提交审核
   */
  putStoreWithDrawal(obj: any) {
    return Ajax.put(``, obj)
  },
  /**
   * 核销
   */
  writeOffCoupon(code: string) {
    return Ajax.put(`/api/MarketingManagement/userCoupon/WriteOffByCode/${code}`)
  },
}
